export const SIGNED_URL_SAFETY_WINDOW_MS = 30 * 1000

export function signedPlaybackExpiry(url, baseOrigin = "https://starlive.invalid") {
  try {
    const parsed = new URL(String(url || ""), baseOrigin)
    const exp = parsed.searchParams.get("exp")
    const expire = parsed.searchParams.get("expire")
    const raw = exp !== null ? exp : expire
    if (raw === null) return 0
    const seconds = Number(raw)
    return Number.isFinite(seconds) && seconds > 0 ? seconds * 1000 : -1
  } catch (_error) {
    return -1
  }
}

export function canStartSignedPlaybackUrl(
  url,
  rejectedUrl = "",
  now = Date.now(),
  baseOrigin = "https://starlive.invalid"
) {
  const value = String(url || "")
  if (!value || value === rejectedUrl) return false
  const expiresAt = signedPlaybackExpiry(value, baseOrigin)
  return expiresAt === 0 || expiresAt > now + SIGNED_URL_SAFETY_WINDOW_MS
}

export function isMpegtsHttp401(type, detail, info = {}) {
  if (Number(info && info.code) === 401) return true
  const message = `${String(type || "")} ${String(detail || "")} ${String(info && info.msg || "")}`
  return message.includes("HttpStatusCodeInvalid") && message.includes("401")
}

export function playbackReconnectDelay(attempt) {
  return Math.min(1000 * 2 ** Math.max(0, Number(attempt || 0) - 1), 10000)
}
